module.exports = __webpack_public_path__ + "img/railway.343b31da.png";